import { useState } from "react";
import { httpClient } from "../Api";
import {
  fetchStart as gFetchStart,
  fetchSuccess as gFetchSuccess,
  fetchError as gFetchError,
  showMessage as gShowMessage,
  hideMessage as gHideMessage,
} from "../../appRedux/actions";
import { useDispatch } from "react-redux";

export const useGroups = () => {
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchStart = () => {
    dispatch(gFetchStart());
  };

  const fetchSuccess = (message) => {
    dispatch(gFetchSuccess());
    dispatch(gShowMessage(message));
  };

  const fetchError = (error) => {
    dispatch(gFetchError(error));
  };

  const addGroup = (group, callbackFun) => {
    fetchStart();
    httpClient
      .post(`Administration/GroupOfCompanies`, group)
      .then(({ data }) => {
        if (data == "Added Successfully") fetchSuccess("Added Successfully");
        if (callbackFun) getGroups(callbackFun);
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const getGroups = (callbackFun) => {
    fetchStart();
    httpClient
      .get(`Administration/GroupOfCompanies`)
      .then(({ data }) => {
        fetchSuccess("");
        if (callbackFun) callbackFun(data);
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const updateGroup = (group, callbackFun) => {
    fetchStart();
    httpClient
      .put(`Administration/GroupOfCompanies`, group)
      .then(({ data }) => {
        fetchSuccess("Updated Successfully");
        if (callbackFun) getGroups(callbackFun);
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  return {
    getGroups,
    addGroup,
    updateGroup,
    isLoading,
    error,
    successMessage,
  };
};
